module App.Classes {
    export interface IPostComposition {
        licensePlate: string;
        storeId: number;
    }

    export class PostComposition  implements IPostComposition  {
        constructor() {
            this.licensePlate = '';
            this.storeId = null;
        }

        licensePlate: string;
        storeId: number;
    }
}